<template>
  <ConfigurationMineTemplate
    :endPointData="endPointData"
    :textData="textData"
  />
</template>
<script setup>
import { computed } from 'vue';

// Utils
import { useRoute } from 'vue-router';
import generateTextData from '@/functions/generate_text_data';

// Components
import ConfigurationMineTemplate from '@/components/generic/configuration_mine_template.vue';

const route = useRoute();

const endPointData = {
  newFormRoute: 'newMineForm',
  operationType: 'mine',
  endpointIdentifier: 'mines',
  mineGroupsEndpoint: `/organisations/${route.params.organisationId}/mines`,
  nav: 'configuration.mine.nav',
};

const mainKey = 'configuration.mine';
const textDataArray = [
  'search',
  'new',
];

const textData = computed(() => {
  return generateTextData(mainKey, textDataArray);
});
</script>
